module.exports = __webpack_public_path__ + "static/media/leftcr10.645e85f0.png";